import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'api-gateway-api.vendasta-local.com',
  'test': '',
  'demo': 'api-gateway-demo.apigateway.co',
  'prod': 'api-gateway-prod.apigateway.co',
  'production': 'api-gateway-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class IntegrationConnectionRequestDataEntry {
  static fromProto(proto) {
    let m = new IntegrationConnectionRequestDataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class IntegrationConnectionResponseDataEntry {
  static fromProto(proto) {
    let m = new IntegrationConnectionResponseDataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class IntegrationConnectionRequest {
  static fromProto(proto) {
    let m = new IntegrationConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.data) {
      m.data = Object.keys(proto.data).reduce((obj, k) => {
        obj[k] = proto.data[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationName !== 'undefined') {
      toReturn['integrationName'] = this.integrationName;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    return toReturn;
  }
}
class IntegrationConnectionResponse {
  static fromProto(proto) {
    let m = new IntegrationConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.data) {
      m.data = Object.keys(proto.data).reduce((obj, k) => {
        obj[k] = proto.data[k];
        return obj;
      }, {});
    }
    if (proto.lastAttempt) {
      m.lastAttempt = new Date(proto.lastAttempt);
    }
    if (proto.lastSuccess) {
      m.lastSuccess = new Date(proto.lastSuccess);
    }
    if (proto.lastDataReceived) {
      m.lastDataReceived = new Date(proto.lastDataReceived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.integrationName !== 'undefined') {
      toReturn['integrationName'] = this.integrationName;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.environment !== 'undefined') {
      toReturn['environment'] = this.environment;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.lastAttempt !== 'undefined' && this.lastAttempt !== null) {
      toReturn['lastAttempt'] = 'toApiJson' in this.lastAttempt ? this.lastAttempt.toApiJson() : this.lastAttempt;
    }
    if (typeof this.lastSuccess !== 'undefined' && this.lastSuccess !== null) {
      toReturn['lastSuccess'] = 'toApiJson' in this.lastSuccess ? this.lastSuccess.toApiJson() : this.lastSuccess;
    }
    if (typeof this.lastDataReceived !== 'undefined' && this.lastDataReceived !== null) {
      toReturn['lastDataReceived'] = 'toApiJson' in this.lastDataReceived ? this.lastDataReceived.toApiJson() : this.lastDataReceived;
    }
    return toReturn;
  }
}
class IntegrationConnectionResponseList {
  static fromProto(proto) {
    let m = new IntegrationConnectionResponseList();
    m = Object.assign(m, proto);
    if (proto.connections) {
      m.connections = proto.connections.map(IntegrationConnectionResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connections !== 'undefined' && this.connections !== null) {
      toReturn['connections'] = 'toApiJson' in this.connections ? this.connections.toApiJson() : this.connections;
    }
    return toReturn;
  }
}
class NamespaceConnectionIDRequest {
  static fromProto(proto) {
    let m = new NamespaceConnectionIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    return toReturn;
  }
}
class NamespaceIntegrationNameRequest {
  static fromProto(proto) {
    let m = new NamespaceIntegrationNameRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationName !== 'undefined') {
      toReturn['integrationName'] = this.integrationName;
    }
    return toReturn;
  }
}
class NamespaceRequest {
  static fromProto(proto) {
    let m = new NamespaceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IntegrationConnectionApiService = /*#__PURE__*/(() => {
  class IntegrationConnectionApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new IntegrationConnectionRequest(r);
      return this.http.post(this._host + "/api_gateway.v1.IntegrationConnectionService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => IntegrationConnectionResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new NamespaceConnectionIDRequest(r);
      return this.http.post(this._host + "/api_gateway.v1.IntegrationConnectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => IntegrationConnectionResponse.fromProto(resp)));
    }
    getMultiByNamespace(r) {
      const request = r.toApiJson ? r : new NamespaceRequest(r);
      return this.http.post(this._host + "/api_gateway.v1.IntegrationConnectionService/GetMultiByNamespace", request.toApiJson(), this.apiOptions()).pipe(map(resp => IntegrationConnectionResponseList.fromProto(resp)));
    }
    getMultiByNamespaceAndIntegration(r) {
      const request = r.toApiJson ? r : new NamespaceIntegrationNameRequest(r);
      return this.http.post(this._host + "/api_gateway.v1.IntegrationConnectionService/GetMultiByNamespaceAndIntegration", request.toApiJson(), this.apiOptions()).pipe(map(resp => IntegrationConnectionResponseList.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new IntegrationConnectionRequest(r);
      return this.http.post(this._host + "/api_gateway.v1.IntegrationConnectionService/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => IntegrationConnectionResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new NamespaceConnectionIDRequest(r);
      return this.http.post(this._host + "/api_gateway.v1.IntegrationConnectionService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  IntegrationConnectionApiService.ɵfac = function IntegrationConnectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationConnectionApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IntegrationConnectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationConnectionApiService,
    factory: IntegrationConnectionApiService.ɵfac,
    providedIn: 'root'
  });
  return IntegrationConnectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { HostService, IntegrationConnectionApiService, IntegrationConnectionRequest, IntegrationConnectionRequestDataEntry, IntegrationConnectionResponse, IntegrationConnectionResponseDataEntry, IntegrationConnectionResponseList, NamespaceConnectionIDRequest, NamespaceIntegrationNameRequest, NamespaceRequest };
